import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useToolManual } from '../hooks/useToolManual';
import './ToolHelpButton.css';

function toKinescopeEmbed(url) {
    if (!url) return '';
    if (url.includes('/embed/')) return url;
    const m = url.match(/kinescope\.ru\/([a-zA-Z0-9_-]+)/);
    return m ? `https://kinescope.ru/embed/${m[1]}` : url;
}

function HelpModal({ title, videoUrl, text, onClose }) {
    return createPortal(
        <div className="thb-modal__overlay" onClick={onClose}>
            <div className="thb-modal__box" onClick={e => e.stopPropagation()}>
                <button className="thb-modal__close" onClick={onClose}>×</button>
                <h3 className="thb-modal__title">{title}</h3>
                {videoUrl && (
                    <div className="thb-modal__video-wrap">
                        <iframe
                            src={toKinescopeEmbed(videoUrl)}
                            title={title}
                            allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
                            allowFullScreen
                            frameBorder="0"
                        />
                    </div>
                )}
                {text && <div className="thb-modal__text">{text}</div>}
            </div>
        </div>,
        document.body
    );
}

// Точечная кнопка помощи рядом с инструментом. Ничего не рендерит, если для
// данного toolKey ещё не заполнен ни video_url, ни текстовая инструкция.
// Рендерится как <span role="button">, а не <button> — чтобы её можно было
// безопасно вкладывать внутрь родительской кнопки таба (button-в-button невалиден).
// Клик останавливает всплытие, чтобы не переключать вкладку.
export default function ToolHelpButton({ toolKey, className = '' }) {
    const { getManual } = useToolManual();
    const [open, setOpen] = useState(false);
    const manual = getManual(toolKey);

    if (!manual || (!manual.video_url && !manual.manual_text)) return null;

    const handleOpen = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setOpen(true);
    };

    return (
        <>
            <span
                role="button"
                tabIndex={0}
                className={`thb-btn ${className}`}
                onClick={handleOpen}
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleOpen(e); }}
                title="Инструкция по инструменту"
            >
                <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 7c-1.5-1.3-3.6-2-6.5-2-.6 0-1 .4-1 1v12c0 .6.4 1 1 1 2.9 0 5 .7 6.5 2 1.5-1.3 3.6-2 6.5-2 .6 0 1-.4 1-1V6c0-.6-.4-1-1-1-2.9 0-5 .7-6.5 2z" />
                    <path d="M12 7v13" />
                </svg>
            </span>
            {open && (
                <HelpModal
                    title={manual.title}
                    videoUrl={manual.video_url}
                    text={manual.manual_text}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    );
}
